export async function getMempoolBlock(block = 0) {
  const fetch = (...args) => import('node-fetch').then(({default: fetch}) => fetch(...args));

  let url;
  if (block != 0)
    url = new URL(`https://mempool.space/api/v1/blocks/${block}`);
  else
    url = new URL(`https://mempool.space/api/v1/blocks`);
  let data = [];
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    data = await response.json();
  } catch (error) {
    console.error('Error fetching data:', error);
  }
  finally {
    return data;
  }
}